import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState, useRef } from "react";
import scrollToComponent from "react-scroll-to-component";
import config from "../../../config"; // import dot from "dot-object";
// Hooks

import useApi from "../../../api"; // Components

import BackButton from "../../../components/BackButton";
import Icon from "../../../components/Icon";
import PackageSlider from "../../../components/PackageSlider";
import Package from "../../../components/Package";
import Advertising from "../../../components/Advertising";
import SocialSharing from "../../../components/SocialSharing";
import Gallery from "../../../components/Gallery";
import { withUserMenu } from "../../../components/UserMenu";
import PackagePlan from "./components/PackagePlan";
import "./details.scss";

var PackageDetailsPageComponent = function PackageDetailsPageComponent(a) {
  var b = a.userMenu,
      c = a.match,
      d = a.location,
      e = a.package,
      f = useRef(null),
      g = useApi(),
      h = useState(),
      i = _slicedToArray(h, 2),
      j = i[0],
      k = i[1],
      l = useState(-1),
      m = _slicedToArray(l, 2),
      n = m[0],
      o = m[1],
      p = function p(a) {
    return function () {
      return o(a);
    };
  },
      q = (c.params.slug || "").toLowerCase(),
      r = _slicedToArray(b, 2),
      s = r[1],
      t = e ? e : g.packages.retrieve(q, {
    extend: "building"
  }); // @TODO add 404 page


  if (useEffect(function () {
    "function" == typeof window.client && t && ("jubilee" === t.project_slug && window.client("456503fe"), "silverwoods" === t.project_slug && window.client("4b84d9ee")), t && s.addRecentlyViewed(t);
  }, [s, t]), !t) return "Package not found";
  var u = "apartment" === t.propertyType,
      v = "townhome" === t.propertyType,
      w = [{
    image: t.image,
    icon: "loupe"
  }].concat(_toConsumableArray(t.gallery || []));
  (t.floor_image || t.floorplan_image) && w.push({
    image: t.floor_image || t.floorplan_image,
    icon: "floorplan"
  }), j && w.push({
    image: j,
    icon: "marker"
  });

  var x = f.current && f.current.offsetParent,
      y = function y() {
    f && f.current && scrollToComponent(f.current, {
      offset: 0,
      align: "top",
      duration: 700,
      ease: "outQuad"
    });
  },
      z = config.flags(t.flags),
      A = "house" === t.propertyType ? "house and land" : t.propertyType,
      B = t.slug.replace("ap/", "").replace("hl/", "").replace("th/", "");

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ta-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement(BackButton, {
    title: "results",
    defaultTo: config.routes.get("property.results")
  }), /*#__PURE__*/React.createElement(SocialSharing, null)), /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement("section", {
    className: "packagedetail"
  }, /*#__PURE__*/React.createElement(Package, {
    package: t,
    isDetail: !0
  }), /*#__PURE__*/React.createElement("div", {
    className: "packagedetail--content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "packagedetail--gallery"
  }, /*#__PURE__*/React.createElement("div", {
    className: "packagedetail--gallery__left",
    onClick: p(0)
  }, /*#__PURE__*/React.createElement("img", {
    src: t.image,
    alt: t.name
  }), z && /*#__PURE__*/React.createElement("span", {
    className: "packagedetail--gallery__flag"
  }, z), t.builder_logo && /*#__PURE__*/React.createElement("img", {
    src: t.builder_logo,
    alt: t.builders_name,
    width: "100px",
    className: "packagedetail--gallery__builder"
  })), /*#__PURE__*/React.createElement("div", {
    className: "packagedetail--gallery__right"
  }, w.map(function (a, b) {
    return a.icon ? /*#__PURE__*/React.createElement("div", {
      key: a.image,
      className: "packagedetail--gallery__thumb",
      style: {
        backgroundImage: "url(".concat(a.image, ")")
      },
      onClick: "marker" === a.icon && x ? y : p(b)
    }, /*#__PURE__*/React.createElement("span", {
      className: "packagedetail--gallery__action"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: a.icon,
      className: a.icon
    }))) : null;
  })), /*#__PURE__*/React.createElement("div", {
    className: "packagedetail--gallery__bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "packagedetail--gallery__viewfloorplan",
    onClick: p(w.length - 2)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "floorplan_black"
  }), " View floor plan"), /*#__PURE__*/React.createElement("div", {
    className: "packagedetail--gallery__count"
  }, "1 of ", w.length))), t.inclusions ? /*#__PURE__*/React.createElement("div", {
    className: "package--inclusions"
  }, /*#__PURE__*/React.createElement("h5", null, "Inclusions"), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: t.inclusions
    }
  })) : null, t.building_amenities ? /*#__PURE__*/React.createElement("div", {
    className: "package--inclusions"
  }, /*#__PURE__*/React.createElement("h5", null, "Building Amenities"), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: t.building_amenities
    }
  })) : null, t.colour_scheme ? /*#__PURE__*/React.createElement("div", {
    className: "package--inclusions"
  }, /*#__PURE__*/React.createElement("h5", null, "Color Scheme"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    dangerouslySetInnerHTML: {
      __html: t.colour_scheme
    }
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "ad--wrapper"
  }, /*#__PURE__*/React.createElement(Advertising, {
    className: "ad--item",
    query: [{
      type: t.propertyType,
      value: B
    }, {
      type: "release",
      value: t.release_slug
    }, {
      type: "neighbourhood",
      value: t.neighbourhood_slug
    }],
    height: 180
  })), /*#__PURE__*/React.createElement("div", {
    ref: f,
    className: "packagedetail--map"
  }, /*#__PURE__*/React.createElement("h4", null, u ? "FLOOR PLATE" : v ? "STREET PLAN" : "LOT PLAN"), /*#__PURE__*/React.createElement(PackagePlan, {
    package: t,
    getMainImage: k
  })))))), /*#__PURE__*/React.createElement(PackageSlider, {
    packages: t.similar,
    title: "Similar ".concat(A)
  }), /*#__PURE__*/React.createElement(Gallery, {
    slides: w,
    show: -1 < n,
    startIndex: n,
    onClose: p(-1)
  }));
};

export var PackageDetailsPage = withUserMenu(PackageDetailsPageComponent);
export default PackageDetailsPage;